<template>
    <v-container fluid fill-height class="flex-column justify-center">
        <v-card 
            color="white"
            class="mx-auto custom-radius"
            width="100%"
            max-width="800"
            elevation="3"
        >
            <v-card-text class="pa-lg-8">
                <img src="@/assets/images/claass-logo-original-without-betta.svg" class="class-logo" />                
                <template v-if="currentStep == 0">
                    <div class="headline text-center mt-8 mb-4" v-text="$t('ChooseProfile')"></div>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-hover v-slot:default="{ hover }">
                                <v-card flat color="grey lighten-4" :elevation="hover ? 3 : 0" @click="selectUserTypeEventHandler(2)">
                                    <v-card-text class="d-flex align-center">
                                        <v-avatar size="50" color="grey lighten-2">
                                            <v-img src="@/assets/images/student-plan.svg"></v-img>
                                        </v-avatar>
                                        <span class="title ml-4" v-text="$t('Student')"></span>
                                    </v-card-text>
                                </v-card>
                            </v-hover>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-hover v-slot:default="{ hover }">
                                <v-card outlined color="grey lighten-4" :elevation="hover ? 3 : 0" to="/en/register/mentor">
                                    <v-card-text class="d-flex align-center">
                                        <v-avatar size="50" color="grey lighten-2">
                                            <v-img src="@/assets/images/tutor-plan.svg"></v-img>
                                        </v-avatar>
                                        <span class="title ml-4" v-text="$t('Mentor')"></span>
                                    </v-card-text>
                                </v-card>
                            </v-hover>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-hover v-slot:default="{ hover }">
                                <v-card flat color="grey lighten-4" :elevation="hover ? 3 : 0" to="/en/register/parent">
                                    <v-card-text class="d-flex align-center">
                                        <v-avatar size="50" color="grey lighten-2">
                                            <v-img src="@/assets/images/parent-plan.svg"></v-img>
                                        </v-avatar>
                                        <span class="title ml-4" v-text="$t('Parent')"></span>
                                    </v-card-text>
                                </v-card>
                            </v-hover>
                        </v-col>
                    </v-row>
                    <div class="text-center mt-2">
                        <div class="mb-6" v-text="$t('SignupDisclaimer')"></div>
                        <span>
                            {{ $t('AlreadyHaveAnAccount') }}
                            <router-link :to="`/${$i18n.locale}`" v-text="$t('SignIn')"></router-link>
                        </span>
                    </div>
                </template>
                <template v-else-if="currentStep == 2">
                    <v-row no-gutters justify="center">
                        <v-col cols="12" lg="10" class="mt-8">
                            <template v-if="studentAgedConditionAnswered && !studentAgedCondition">
                                <template v-if="parentEmailSend">
                                    <v-alert
                                        type="success"
                                    >Email send successfully</v-alert>
                                </template>
                                <template v-else>
                                    <v-text-field
                                        dense
                                        outlined
                                        rounded
                                        required
                                        validate-on-blur
                                        v-model="parentName"
                                        :rules="parentNameRule"
                                        :label="$t('PleaseProvideParentName')"
                                    ></v-text-field>
                                    <v-text-field
                                        dense
                                        outlined
                                        rounded
                                        required
                                        validate-on-blur
                                        type="email"
                                        v-model="parentEmail"
                                        :rules="parentEmailRule"
                                        :label="$t('PleaseProvideParentEmail')"
                                    ></v-text-field>
                                    <div class="text-center">
                                        <v-btn 
                                            depressed 
                                            rounded 
                                            color="primary" 
                                            :disabled="!isParentEmailValid"
                                            @click="sendParentEmail"
                                            v-text="$t('Send')"
                                        ></v-btn>
                                    </div>
                                </template>
                            </template>
                            <template v-else-if="studentAgedCondition == 0">
                                <div class="text-center">
                                    <v-btn 
                                        depressed 
                                        rounded 
                                        class="mx-2" 
                                        color="primary" 
                                        to="/en/register/student"
                                        v-text="$t('IAmAtLeast18')"
                                    ></v-btn>
                                    <v-btn 
                                        depressed 
                                        rounded 
                                        class="mx-2" 
                                        color="primary" 
                                        @click="agedResponseEventHandler(false)"
                                        v-text="$t('IAmUnder18')"
                                    ></v-btn>
                                </div>
                            </template>
                        </v-col>
                    </v-row>
                </template>
            </v-card-text>                                   
        </v-card>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        data() {
            return {
                currentStep: 0,
                registrationType: this.$route.query.plan ? parseInt(this.$route.query.plan) : 0,
                serverErrors: '',
                studentAgedConditionAnswered: false,
                studentAgedCondition: false,
                parentName: '',
                parentEmail: '',
                parentEmailSend: false,
                parentNameRule: [val => (val || '').length > 0 || ''],
                parentEmailRule: [
                    val => (val || '').length > 0 || '',
                    val => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(val) || 'Invalid e-mail'
                    }
                ],
                timezones: [],
                registered: false,
                showPasswordTooltip: false,
                termAndCondition: {},
                loadingTerms: true,
                termAndConditionDialog: false,
                loadingTimezones: true,
                honey: null,
                submitting: false,
            }
        },
        computed: {
            ...mapGetters(['languages', 'defaultLanguage']),
            isParentEmailValid() {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                if(this.parentEmail && pattern.test(this.parentEmail) && this.parentName) {
                    return true
                }
                return false
            }
        },
        mounted() {

        },
        methods: {
            selectUserTypeEventHandler(typeId) {
                this.registrationType = typeId
                if(typeId == 1 || typeId == 7) {
                    this.currentStep = 3
                } else if(typeId == 2) {
                    this.currentStep = 2
                }
            },
            agedResponseEventHandler(value) {
                this.studentAgedConditionAnswered = true
                this.studentAgedCondition = value
                if(value) {
                    this.currentStep = 3
                }
            },
            sendParentEmail(){
                this.axios.post(`/User/NotifyParentForRegistration?email=${this.parentEmail}&name=${this.parentName}&languageId=${this.defaultLanguage.id}`)
                .then(response => {
                    this.parentEmailSend = true
                })
                .catch(error => {
                    const snackbar = {
                        show: true,
                        message: errror.message
                    }
                    this.$EventBus.$emit('snackbar', snackbar)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.container--fluid{
    background-image: url('~@/assets/images/landing-page.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    .class-logo{
        display: block;
        max-width: 100%;
        height: 135px;
        margin: 0 auto;
    }
}
.dialog-content{
    p{
        margin-bottom: 0;
    }
}
</style>